<table class="table table-striped rank-table">
  <tbody>
    <tr *ngFor="let item of truncatedList" [tooltip]="toolTipTemplate">
      <td>
        <a
          [routerLink]="item.href"
          (click)="setTitle('School Profile')"
          class="link_small"
          *ngIf="!isRestrictedUser"
        >
          {{ item.name }}
        </a>
        <span class="rank_list_value" *ngIf="isRestrictedUser">{{
          item.name
        }}</span>
      </td>
      <td [style.color]="item.color" class="align-right rank_list_value">
        {{ dataPrefix }}{{ item.y | commas }}{{ dataSuffix }}
      </td>
      <ng-template #toolTipTemplate>
        <div class="highcharts-tooltip">
          <span>
            <div>
              <span class="metric-tooltip title capitalize tile_body">{{
                item.name
              }}</span>
              <span
                class="metric-tooltip value tooltip_value"
                [ngStyle]="{ color: item.color }"
                >{{ dataPrefix }}{{ item.y | commas }}{{ dataSuffix }}</span
              >
            </div>
            <div
              class="metric-tooltip description body_tooltip_text"
              *ngIf="dataSuffix"
            >
              <strong>{{ dataPrefix }}{{ item.numerator | commas }}</strong> of
              <strong>{{ dataPrefix }}{{ item.denominator | commas }}</strong>
              {{ item.descriptor }}
            </div>
            <div
              class="metric-tooltip description body_tooltip_text"
              *ngIf="!dataSuffix"
            >
              <strong>{{ dataPrefix }}{{ item.numerator | commas }}</strong>
              {{ item.descriptor }}
            </div>
          </span>
        </div>
      </ng-template>
    </tr>
  </tbody>
</table>
